<template>

  <router-btn :text="$t('servicesystem.common_objects.commonterms.service_report')" :icon="'mdi-receipt-text'"
    :color="'secondary'" :disabled="false" outlined :textbtn="textbtn" :large="large" :small="small" @Press="travel()">
  </router-btn>

  <!--
  <span>
    <v-btn @click="open()"
           small
           color="secondary">
      {{$t('servicesystem.common_objects.commonterms.service_report')}}
    </v-btn>
    <service-report-dialog height="800" width="800" ref="sr"></service-report-dialog>
  </span> 
  -->
</template>


<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";
//import ServiceReportDialog from "../Dialogs/ServiceReportDialog.vue";
import clientAPI from "@/api/ClientAPIMixin.js";

export default {
  name: "ServiceReportBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn /*ServiceReportDialog*/ },
  mixins: [clientAPI],

  data() {
    return {};
  },

  methods: {
    /*
    open() {
      this.$refs.sr.open();
    },
    */

    travel() {
      this.GetServiceReportLink(this.$route.params.jobId, true);
    },
  },
};
</script>
